import { Typography as TypographyLib } from 'antd';

export default TypographyLib.Text;
